<template>
    <div class="w-full min-h-[60vh] largeDesktop:min-h-[80vh]">
        <div
            class="myHappyHomeLandingPage relative border-1 rounded-[20px] min-w-full p-[5px] tablet:px-[20px] pt-[30px] laptop:pt-[20px] !pb-[40px] mb-[50px] bg-opacity-50 bg-[#fff] border-[#CCCCCC]">

            <div class="absolute -top-[20px] largeDesktop:-top-[22px] right-5 flex items-center gap-3 z-10">
                <!-- Share Plan -->
                <div @click="shareModal()"
                    class="transform lg:hover:scale-[1.05] active:scale-[0.98] duration-300 group mobile:bg-customBlue-100 laptop:bg-white laptop:hover:!bg-customBlue-100 hover:text-white transition-all cursor-pointer flex items-center justify-center gap-2.5 rounded-full px-2.5 laptop:px-3 largeDesktop:px-4 h-[38px] largeDesktop:h-[42px] w-max shadow-[0px_0px_10px_0px_#00000026;] mobile:text-white laptop:text-black-100">
                    <img src="../../assets/images/Share-plan-icon.png" alt="Share Icon"
                        class="w-[24px] h-[24px] mobile:hidden laptop:group-hover:hidden laptop:block">
                    <img src="../../assets/images/Share-plan-hover.png" alt="Share Icon"
                        class="w-[24px] h-[24px] mobile:block laptop:group-hover:block laptop:hidden">
                    <p class="mb-0 text-[16px] laptop:text-[18px] font-normal font-poppins">Share</p>
                </div>
                <div @click="cartModal()"
                    class="transform lg:hover:scale-[1.05] active:scale-[0.98] duration-300 transition-all cursor-pointer flex items-center gap-2 rounded-full p-[5px] !pr-2 largeDesktop:p-[5px] w-max shadow-[0px_0px_10px_0px_#00000026;] bg-white"
                    :class="{ '!cursor-not-allowed': cartCountResponse == null || !(cartCountResponse['myhappyhome-bundle'] ?? 0 > 0) }">
                    <div class="flex items-center gap-2 rounded-full px-2.5 py-0.5 w-max bg-customBlue-100"
                        :class="{ '!bg-[#ccc]': cartCountResponse == null || !(cartCountResponse['myhappyhome-bundle'] ?? 0 > 0) }">
                        <img src="../../assets/images/cart-check-white.png" alt="Cart Icon" class="w-[22px] h-[22px]">
                        <span class="text-base largeDesktop:text-lg font-roboto font-bold text-white">{{
                            !(cartCountResponse['myhappyhome-bundle']
                                ?? 0 > 0) ? 0 : cartCountResponse?.items_count || 0 }}</span>
                    </div>
                    <span
                        class="font-roboto font-medium laptop:font-semibold text-lg largeDesktop:text-2xl text-black-100"
                        :class="{ '!text-[#ccc]': cartCountResponse == null || !(cartCountResponse['myhappyhome-bundle'] ?? 0 > 0) }">${{
                            $helper.formatAmount(!(cartCountResponse['myhappyhome-bundle'] ?? 0 > 0) ? 0 :
                                cartCountResponse?.total_amount || 0)
                        }}</span>
                </div>
            </div>
            <div class="items-center gap-[12px] w-full  pb-[15px] flex pl-2 laptop:pl-0">
                <div class="flex items-center gap-[5px]">
                    <span class="block w-[8px] h-[8px] rounded-full bg-[#F5B134]"></span>
                    <span class="block w-[35px] h-[8px] rounded-full bg-[#F5B134]"></span>
                </div>
                <h1 class="m-0 text-[20px] font-roboto font-bold text-customBlue-100">MyHappyHome
                </h1>
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-2 justify-center gap-[30px] laptop:gap-[15px] desktop:gap-[30px] w-full">
                <div v-for="(item, index) in product" :key="index"
                    :class="item.is_maintenance === 1 ? 'flex flex-col justify-between' : ''">
                    <div
                        class="border-0 w-full   p-[20px] shadow-[0px_0px_10px_0px_#0000001A] rounded-[20px] bg-[#fff]">
                        <!-- <div class="items-center gap-[12px] w-full pb-[15px] laptop:hidden mobile:flex">
                            <div class="flex items-center gap-[5px]">
                                <span class="block w-[8px] h-[8px] rounded-full bg-[#F5B134]"></span>
                                <span class="block w-[35px] h-[8px] rounded-full bg-[#F5B134]"></span>
                            </div>
                            <h1 class="m-0 text-[20px] font-roboto font-bold text-customBlue-100">MyHappyHome </h1>
                        </div> -->
                        <div class="flex items-center justify-between gap-[12px]">
                            <h2
                                class="text-[20px] tablet:text-[22px] mb-1.5 font-semibold font-roboto text-left text-[#333333]">
                                {{
                                    item.bundle_name }}</h2>
                            <div class="w-1/2 flex items-center justify-end">
                                <div class="text-left w-max">
                                    <h6 class="hidden mb-[5px] text-[16px] font-medium font-roboto text-customYellow-100">
                                        Monthly</h6>
                                    <h2 class="m-0 text-[25px] laptop:text-[30px] font-bold font-roboto text-[#333333]">
                                        ${{ $helper.formatAmount(item.amount) }}<span class="text-[20px]">/mo</span>
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col pt-2.5">
                            <div class="pb-[10px] border-b border-[#EFEFEF]">
                                <!-- <h2
                                    class="tablet:hidden mobile:block text-[18px] laptop:text-[22px] mb-0 font-medium font-roboto text-[#333] text-left">
                                    {{ item.bundle_name }}</h2> -->
                                    <p v-if="item.description.length > 0"
                                        class="m-0 text-justify text-[16px] font-medium font-roboto leading-tight text-[#666] ">
                                        {{
                                            item.description }}</p>
                            </div>
                        </div>
                        <addons :addons="getAddonData(item.plans)" :addonsInfoImg="item.is_maintenance == 0" />
                        <div class="py-[10px] pt-[30px] flex justify-center items-center gap-2.5 tablet:gap-4">
                            <span :id="index === 0 ? 'tour-select-plan' : ''" v-if="item.quantity == 0" @click="updateCounter('increment', item)"
                                class="CustomBlueBtn group w-[150px] h-[40px] flex justify-center items-center gap-1 font-roboto text-sm rounded-full cursor-pointer">
                                <!-- <img src="../../assets/images/cart-check.svg"
                                    class="w-[22px] h-[22px] object-contain hidden laptop:block laptop:group-hover:hidden" alt="icon"> -->
                                <img src="../../assets/images/cart-check-white.png"
                                    class="w-[22px] h-[22px] object-contain " alt="icon">
                                Select this plan
                            </span>
                            <div v-else class="flex justify-center items-center smallMobile:!gap-3 gap-4">
                                <quantityCounter v-if="item.is_show_quantity == 1" :quantity="item.quantity"
                                    :product="item" @update-counter="updateCounter" />
                                <button v-else type="button" @click="updateCounter('remove', item)"
                                    class="transform lg:hover:scale-[1.15] active:scale-[0.98] duration-300 group !h-10 !w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-orange-100 !bg-transparent hover:!bg-orange-100">
                                    <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                                        class="!w-7 !h-7 group-hover:hidden">
                                    <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                                        class="!w-7 !h-7 hidden group-hover:!block">
                                </button>
                                <img src="../../assets/images/cart-icon-with-bg.svg" alt="Cart Icon"
                                    class="smallMobile:!w-[38px] !w-10 smallMobile:!h-[38px] !h-10">
                            </div>
                            <span :id="index === 0 && item.is_maintenance == 0 ? 'tour-review-coverage' : ''" v-if="item.is_maintenance == 0" @click="openCoverageModal()"
                                class="CustomYellowBtn group w-[200px] tablet:w-[250px] h-[40px] flex justify-center items-center gap-1 font-poppins font-medium text-[12px] tablet:text-[14px] rounded-full cursor-pointer 
                                border-[1px] border-[#F5B134] bg-[#FDF9EE] !shadow-none laptop:hover:!shadow-[0px_5px_10px_0px_#f5b13466]">
                                Review Coverage Amount 
                            </span>
                        </div>
                    </div>
                    <div v-if="item.is_maintenance === 1" class="hidden lg:block w-full xl:w-[430px] mx-auto">
                        <img src="../../assets/images/truck-img.png" class="h-full w-full object-contain" alt="img">
                    </div>
                </div>
            </div>
            <button id="tour-continue-checkout" v-if="(cartCountResponse['myhappyhome-bundle'] ?? 0 > 0) || tourDummyCheckout" @click="continueClicked"
                :disabled="!((cartCountResponse['myhappyhome-bundle'] ?? 0 > 0) || tourDummyCheckout)"
                class="absolute -bottom-5 translate-x-1/2 tablet:translate-x-[unset] right-[50%] tablet:right-[20px] text-[14px] font-roboto font-medium rounded-full py-[9px] px-[18px] 
                CustomBlueBtn">Continue
                to Checkout</button>
        </div>
    </div>

    <!-- Addons Modal -->
    <addonsModal ref="addonsModalRef" />
    <!-- Cart Modal -->
    <bundleCartModal ref="bundleCartModalRef" @close-cart-modal="cartmodalOpen = false"
        :continueClicked="continueClicked" :updateCart="updateCart" :openCoverageModal="openCoverageModal" />
    <!-- coverage Modal -->
    <coverageModal ref="coverageModalRef" :cartmodal-open="cartmodalOpen" />
    <!-- planDetailModal -->
    <div class="modal fade bg-[#00000063] " ref="planDetailModal" id="planDetailModal" tabindex="-1" aria-labelledby="planDetailModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!px-3 tablet:!px-0 mobile:!min-w-full mobile:!max-w-full tablet:!w-[500px] tablet:!min-w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class="modal-body !p-3 !pb-5">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-[10px] w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                        <div
                            class="rounded-lg overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
                            <span
                                class="text-sm font-lato font-normal m-0 rounded-full w-max px-[15px] block bg-customYellow-100 text-white">{{
                                    addonPlanDetails?.trade_name ?? '' }}</span>
                            <h4 class="text-xl font-normal font-roboto m-0 text-white">{{
                                addonPlanDetails?.plan_name ?? '' }}</h4>
                        </div>
                    </div>
                    <div ref="scrollBox" class="max-h-[550px] overflow-y-auto customScrollbar px-2.5 mt-[25px] py-1">
                        <!-- <customAccordion :items="getCoveredData()" /> -->
                        <div v-if="!$helper.isEmpty($helper.getCleanText(addonPlanDetails?.covered))"
                            class="shadow-[0px_0px_10px_0px_#00000026] p-[15px] !rounded-[10px] overflow-hidden">
                            <h4 class="w-full text-lg font-roboto mb-1.5 text-left bg-transparent !text-customBlue-100">
                                Included:</h4>
                            <div v-html="addonPlanDetails?.covered" class="bundleDescription">
                            </div>
                        </div>
                        <div v-if="!$helper.isEmpty($helper.getCleanText(addonPlanDetails?.not_covered))"
                            class="shadow-[0px_0px_10px_0px_#00000026] p-[15px] !rounded-[10px] overflow-hidden mt-3">
                            <h4 class="w-full text-lg font-roboto mb-1.5 text-left bg-transparent !text-customBlue-100">
                                Excluded:</h4>
                            <div v-html="addonPlanDetails?.not_covered" class="bundleDescription excludedItems">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <sharePlanModal ref="openSharePlanModal" />
</template>

<script>
import { Modal } from "bootstrap";
import { data } from 'jquery';
import sharePlanModal from "../../components/partialComponent/sharePlanModal.vue";
import addons from '../../components/nest_components/addons/addons.vue';
import addonsModal from '../../components/nest_components/addons/addons_modal.vue';
import bundleCartModal from '../../components/nest_components/addons/bundle_cart_modal.vue';
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/plugins/EventBus";
import { isTourActive } from "../../services/tourService";
import quantityCounter from '../../components/partialComponent/quantityCounter.vue';
import 'vue3-carousel/dist/carousel.css';
import { Slide } from 'vue3-carousel';
import customSlider from '../../components/partialComponent/customSlider.vue';
import coverageModal from "../../components/nest_components/coverage/coverage_modal.vue";
export default {
    components: {
        addons,
        addonsModal,
        quantityCounter,
        bundleCartModal,
        sharePlanModal,
        coverageModal
    },
    computed: {
        ...mapGetters([
            "selectedProtectionPlan",
            "protectionPlanBundle",
            "cartValidate",
            "removeProtectionCartData",
            "cartUpdated",
            "cartCountResponse",
            "addonPlanDetails"
        ]),
    },

    watch: {

        selectedProtectionPlan: function (data) {
            this.getBundleData()
        },

        protectionPlanBundle: function (data) {
            if (data.length > 0)
                this.product = data
        },

        removeProtectionCartData: function (data) {
            if (this.$refs.bundleCartModalRef) {
                this.cartmodalOpen = false
                this.$refs.bundleCartModalRef.closeModal()
            }
            this.getCartCount({})
            // this.upsertCart({
            //     "bundle_id": this.selectedProduct.id,
            //     "quantity": this.selectedProduct.quantity,
            //     "partner_id": this.selectedProduct.partner_id
            // })

        },
        cartValidate: function (data) {

            if (this.cartValidate.validation_passed) {

                this.upsertCart({
                    "bundle_id": this.selectedProduct.id,
                    "quantity": this.selectedProduct.quantity,
                    "partner_id": this.selectedProduct.partner_id
                })

            }
            else {

                this.$confirmDialog.show({
                    title: "Action Required",
                    message: this.cartValidate.message,

                    onConfirm: () => {
                        this.removeBundle(this.cartValidate)
                    },
                });
            }

        },

        cartUpdated: function (data) {

            this.isLoading = true
            this.getBundleData()
            this.getCartCount({})
            // this.$refs.addonsModalRef.openModal();

        },

        cartCountResponse: function (data) {
            if (this.cartCountResponse.has_repair == false && (this.cartCountResponse.item_ids ?? []).length > 0) {
                this.removeProtectionItemCart({
                    "bundle_ids": this.cartCountResponse.item_ids ?? [],
                    "plan_ids": [],
                })
            }
        },

        addonPlanDetails: function (data) {

            const modalEl = this.$refs.planDetailModal;
            if (this.modal) return
            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });
            document.documentElement.style.overflow = 'hidden';
            this.adjustPlanModalHeight();
            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                document.documentElement.classList.remove("overflow-hidden");
                document.documentElement.style.overflow = '';
                this.modal = null
                window.addEventListener('resize', this.adjustPlanModalHeight);
                window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            modalEl.addEventListener("shown.bs.modal", () => {
                if (this.$refs.scrollBox) {
                    this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                }
            });
            this.modal.show();
        },
    },

    data() {
        return {
            isLoading: true,
            product: [],
            selectedProduct: null,
            cartmodalOpen: false,
            tourDummyCheckout: localStorage.getItem('my_happy_home_tour_dummy_checkout') === 'true'
        };
    },


    mounted() {
        // Clear dummy flag on mount to prevent persistence from previous sessions
        localStorage.removeItem('my_happy_home_tour_dummy_checkout');
        this.checkTourDummy(); // Update local state immediately
        this.getCartCount({})
        EventBus.on('tourDummyTrigger', this.checkTourDummy);
    },
    unmounted() {
        localStorage.removeItem('my_happy_home_tour_dummy_checkout');
        EventBus.off('tourDummyTrigger', this.checkTourDummy);
    },
    methods: {

        ...mapActions([
            "getProtectionPlansBundle",
            "validateCart",
            "removeProtectionItemCart",
            "upsertCart",
            "getCartCount",
        ]),
        shareModal() {
            this.$refs.openSharePlanModal.openModal()
        },
        removeBundle(data) {
            this.removeProtectionItemCart({
                "bundle_ids": data.bundle_ids,
                "plan_ids": data.plan_ids,
            })
        },

        cartModal() {
            if (this.cartCountResponse == null || !(this.cartCountResponse['myhappyhome-bundle'] ?? 0 > 0)) return
            this.cartmodalOpen = true
            this.$refs.bundleCartModalRef.openModal()
        },

        getAddonData(data) {
            const groupedData = data.reduce((acc, item) => {
                const key = item.trade_name;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
            console.log("groupedData", groupedData);
            return groupedData


        },
        continueClicked() {

            if (this.product.quantity == 0) {
                this.validateCart({
                    "bundle_id": this.product.id,
                    "quantity": 1,
                    "partner_id": this.product.partner_id ? this.product.partner_id : this.selectedProtectionPlan.partner_id

                })
            }
            else {
                if (this.cartCountResponse.has_repair == false) {
                    document.documentElement.classList.remove("overflow-hidden");
                    this.modal = null
                    this.$router.push({
                        name: 'partnerCheckout'
                    })
                } else {
                    this.$refs.addonsModalRef.openModal();
                }

            }
        },

        getBundleData() {
            if (this.isLoading) {
                this.isLoading = false
                this.getProtectionPlansBundle({ 'partner_id': this.selectedProtectionPlan.partner_id, "route_slug": this.selectedProtectionPlan.route_slug });
            }
        },

        openCoverageModal() {
            this.$refs.coverageModalRef.openModal()
        },
        
        updateCounter(option, item) {
            let quantity = JSON.parse(JSON.stringify(item.quantity))
            if (option == "increment") {
                quantity++
            } else if (option == "decrement" || option == "remove") {
                if (quantity > 1) {
                    quantity--
                } else {
                    quantity = 0
                }
            } else {
                quantity = 0
            }
            this.updateCart(option, {
                id: item.id,
                quantity: quantity,
                partner_id: item.partner_id,
                type: 'bundle'
            })
            document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
        },

        updateCart(option, plan, type = 'bundle', action = 'update') {
            this.selectedProduct = plan
            if (option == 'decrement' || option == 'remove') {
                this.upsertCart({
                    "bundle_id": plan.id,
                    "quantity": plan.quantity,
                    "partner_id": plan.partner_id
                })
            }
            else {
                this.validateCart({
                    "bundle_id": plan.id,
                    "quantity": plan.quantity,
                    "partner_id": plan.partner_id

                })
            }
        },

        adjustPlanModalHeight() {
            const modalContent = this.$refs.scrollBox;
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 300) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 991) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 1440) {
                    maxHeight = vh * 0.8 - 50;
                }
                else {
                    maxHeight = vh * 0.8 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },
        checkTourDummy() {
            const isDummySet = localStorage.getItem('my_happy_home_tour_dummy_checkout') === 'true';
            const isTourRunning = document.documentElement.classList.contains('tour-active');
            
            // Only show dummy checkout if key is set AND tour is actually running on the page
            this.tourDummyCheckout = isDummySet && isTourRunning;
        }
    },
};
</script>
<style>
.modal {
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}
.myHappyHomeLandingPage:has(>.driver-active-element){
   overflow: visible !important;
}
</style>